import { Dialog } from '@radix-ui/react-dialog'

import { Button } from '@/components/button/button'
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { type ResMember } from '@/lib/queries/business/v1/types'
import { cn } from '@/lib/utils'

export interface RemoveConfirmDialogProps {
  memberData: ResMember
  isPendingRemove: boolean
  onOpenChange: (open: boolean) => void
  onClickCancelButton: VoidFunction
  onClickRemoveButton: (memberData: ResMember) => void
}

export const RemoveConfirmDialog = ({
  memberData,
  isPendingRemove,
  onOpenChange,
  onClickCancelButton,
  onClickRemoveButton,
}: RemoveConfirmDialogProps) => {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove {memberData.email} ?</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            Remove {memberData.email} from invites pending list.
          </DialogDescription>
        </DialogHeader>
        <div className={cn('text-[14px] font-normal leading-[20px] text-[#64748B]')}>
          <p>{memberData.email} will no longer have access to Lawfully.</p>
          <p>They may still have access to team resources like projects and files.</p>
        </div>
        <DialogFooter>
          <div className={cn('flex justify-end', 'space-x-2')}>
            <Button variant="outline" onClick={onClickCancelButton}>
              Cancel
            </Button>
            <Button variant="destructive" loading={isPendingRemove} onClick={() => onClickRemoveButton(memberData)}>
              Remove
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
